import { enumDividerDirection } from "../constants";
import { QElement } from "./QElement";
import { Globals } from "./Globals";

export class QDivider extends QElement {
  constructor() {
    super();
    this.fDirection = enumDividerDirection.vertDivider;
    this.fInset = 0;
    this.fFillBackground = false; // false;
    this.fEtch = false;
    this.fFillStyle = "#ffffff"; // "#F0F1F4";
    this.fStrokeStyle = "#999999";
    this.fHideDivider = false;
    this.SetEnabled(false);
  }

  InitDivider(theDirection, inset, fillBackground) {
    this.fDirection = theDirection;
    this.fInset = inset;
    this.fFillBackground = fillBackground;
  }

  SetEtchState(etchState) {
    this.fEtch = etchState;
  }

  SetHideDivider(hide) {
    this.fHideDivider = hide;
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    var xPos = this.fHorzOffset;
    var yPos = this.fVertOffset;
    ctx.strokeStyle = this.fStrokeStyle;
    if (this.fFillBackground) {
      ctx.fillStyle = this.IsGradientFill() ? this.GetGradient(ctx) : this.fFillStyle;
      if (this.fClippedRegion) {
        ctx.strokeStyle = this.GetBorderColor();
        ctx.fill(this.fClippedRegion);
        ctx.stroke(this.fClippedRegion);
        ctx.restore();
        return;
      } else ctx.fillRect(xPos, yPos, this.fWidth * Globals._dpr, this.fHeight * Globals._dpr);
    }

    ctx.lineJoin = "miter";
    ctx.lineCap = "square";
    var hSize = this.fWidth;
    var vSize = this.fHeight;
    var hStart, hDest;
    var vStart, vDest;
    var lineWidth = 1;

    if (this.fLineWidth) lineWidth = this.fLineWidth;

    if (this.fDirection === enumDividerDirection.horzDivider) {
      hStart = this.fInset;
      hDest = hSize - this.fInset;
      vStart = vSize / 2;
      vDest = vStart;
    } else {
      hStart = hSize / 2; // Math.round(hSize/2);
      hDest = hStart;
      vStart = this.fInset;
      vDest = vSize - this.fInset;
    }

    ctx.lineWidth = lineWidth;
    var x1 = xPos + hStart;
    var x2 = xPos + hDest;
    var y1 = yPos + vStart;
    var y2 = yPos + vDest;

    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.closePath();

    if (!this.fHideDivider) ctx.stroke();

    if (false) {
      ctx.strokeStyle = "#ffffff";
      ctx.beginPath();

      if (this.fDirection === enumDividerDirection.vertDivider) {
        ctx.moveTo(x1 + 1, y1 - 1);
        ctx.lineTo(x1 + 1, y2 + 1);
        ctx.lineTo(x1 - 1, y2 + 1);
        ctx.lineTo(x1 - 1, y1 - 1);
        ctx.lineTo(x1 + 1, y1 - 1);
      } else {
        ctx.moveTo(x2 + 1, y1 - 1);
        ctx.lineTo(x2 + 1, y2 + 1);
        ctx.lineTo(x1 - 1, y2 + 1);
        ctx.lineTo(x1 - 1, y1 - 1);
        ctx.lineTo(x2 + 1, y1 - 1);
      }

      //	   	 ctx.closePath();
      ctx.stroke();
    }
    ctx.restore();
  }
}
